import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Dropdown } from '../../../../../../../components/Dropdown';
import { Loader } from '../../../../../../../components/Loader';
import { VehicleCreateFieldCompanyUser } from '../../../../../pages/create/FieldCompanyUser';
import { initiateNewOrderValue, setNewOrderValue } from '../../../../../actions';
import { selectNewOrder, selectNewOrderValue } from '../../../../../selectors';
import { selectWork } from '../../../../../../Api/selectors';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../../../../../constants';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { getPropByName } from '../../../../../../../utils/props';
import { Button } from '../../../../../../../components/Buttons';
import { SlideSelect } from '../../../../../../../components/SlideSelect';
import cn from 'classnames';
import CheckboxComponent from '../../../../../../../containers/App/Components/Checkbox/Checkbox';
import ButtonComponent from '../../../../../../../containers/App/Components/Button/Button';
import styles from './Fields.module.css';
import { fixPriceFormat, formatLicensePlate, getQuantOfDecimalPlaces } from '../../../../../../../utils/string';
import { VehicleAvatar } from '../../../../../../../components/VehicleAvatar';
import { CompanyUsersSearchSelect } from '../../../../../pages/create/CompanyUsersSearchSelect';
import { calculateFinancialAmounts } from '../../../../../../Invoices/actions';
import { INVOICE_DIRECTIONS, INVOICE_SUBJECT_TYPES } from '../../../../../../Invoices/constants';

dayjs.extend(customParseFormat);
const DROPDOWN_OPTIONS = {
  transport: ['is_available', 'pickup', 'deliver'],
  picked_up: ['0', '1'],
};

const BUTTONS_OPTIONS = {
  tax_type: ['excl.BTW/BPM', 'incl.BTW/BPM'],
};

const Container = styled.div`
  margin-bottom: 8px;
  .formField {
    .label {
      text-transform: capitalize;
      margin-bottom: 6px;
      color: #6c757d;
    }
  }

  .rightDecorationBlock {
    width: 100px;
    display: flex;

    .deleteBtn {
      background-color: #d50046;
    }
  }
`;

const STATE = {
  value: '',
};

/* eslint-disable react/prefer-stateless-function */
class VehicleCreateOrderFieldComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.initiateValue();

    if (this.props.type == 'seller') {
      this.props.setValue(this.props.loggedInuser, this.props.type);
    }

    if (this.props.type == 'transport') {
      const defaultValue = getPropByName(this.props.outgoingCompany, 'prefence_outgoing_transport');
      defaultValue && this.props.setValue(defaultValue, this.props.type);
    }

    if (this.props.type == 'release_before_outgoing_transport') {
      const defaultValue = getPropByName(this.props.outgoingCompany, 'release_before_outgoing_transport');
      defaultValue ? this.props.setValue('1', this.props.type) : this.props.setValue('0', this.props.type);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.secondaryTotalPrice != this.props.secondaryTotalPrice) {
      return this.props.setValue(this.props.values.main_cost + this.props.secondaryTotalPrice, 'total_price');
    }

    if (this.props.values.BPM_refund === '1' && this.props.values.BPM_refund_via_indewal === '1') {
      this.props.setValue('1', 'zulassung_aanvragen');
    }
  }

  getVehicleSubjectDto(mainCost) {
    let priceField = '';
    if (this.props.vehicle?.tax_type == 'BTW') {
      priceField = 'financial_price_incl_vat_bpm';
    }
    if (this.props.vehicle?.tax_type == 'marge') {
      priceField = 'financial_price_marge_incl_bpm';
    }
    const dto = {
      direction: INVOICE_DIRECTIONS.OUTGOING,
      subject_type: INVOICE_SUBJECT_TYPES.VEHICLE,
      vehicleId: this.props.vehicle?.id,
      isBrutoScenario: false,
      tax_type: this.props.vehicle?.tax_type,
      outgoingCompanyId: this.props.values.outgoingCompanyId,
      salesAmounts: {
        [priceField]: +mainCost,
      },
    };

    return dto;
  }

  calculate(mainCost) {
    this._t = this.timeout(() => this.calculateFinancialAmounts(mainCost), 1000, this._t);
  }

  calculateFinancialAmounts(mainCost) {
    const subject = this.getVehicleSubjectDto(mainCost);
    this.props.calculateFinancialAmounts(subject, result => {
      this.props.setValue(result, 'priceDetails');
    });
  }

  onSetFixedValue(value) {
    const roundValue = value ? parseFloat(value?.replace(',', '.')) : value;
    const fixedValue = fixPriceFormat(roundValue);
    this.props.setValue(fixedValue);
    if (this.props.type === 'main_cost') {
      this.calculate(fixedValue);
      this.props.setValue(fixedValue + +this.props.secondaryTotalPrice, 'total_price');
    }

    this.props.saveDisable(false);
    return fixedValue;
  }

  onChangePriceWithRounding(enteredValue) {
    this.props.saveDisable(true);
    const value = enteredValue || '';
    if (getQuantOfDecimalPlaces(value) > 2) return;
    this.props.setValue(value);

    if (value) {
      this._t = this.timeout(() => this.onSetFixedValue(value), 2500, this._t);
    }
    return;
  }

  isCheckbox() {
    return ['release_before_outgoing_transport'].indexOf(this.props.type) > -1;
  }

  isDropbox() {
    return this.props.type in DROPDOWN_OPTIONS;
  }

  isButtonsOptions() {
    return null;
  }

  isButtonBlock() {
    return ['sell_with_license_plate', 'fix_damages'].indexOf(this.props.type) > -1;
  }

  isSlideSelect() {
    return ['BPM_refund', 'BPM_refund_via_indewal', 'zulassung_aanvragen'].indexOf(this.props.type) > -1;
  }

  isTextariaBlock() {
    return ['fixed_damages_details'].indexOf(this.props.type) > -1;
  }

  wrap(children) {
    if (this.isSlideSelect()) return this.slideSelect();
    switch (this.props.type) {
      default:
        return <div className={styles.formField}>{children}</div>;
    }
  }

  slideSelect() {
    return (
      <div className={styles.slideSelect}>
        <label className="form-label">{this.lbl(`vehicle.order.${this.props.type}`)}</label>
        <SlideSelect
          selected={this.props.value == 1}
          checkedLabel={this.lbl('YES')}
          notCheckedLabel={this.lbl('NO')}
          onChange={() => {
            const value = this.props.value === '1' ? '0' : '1';

            return this.props.setValue(value);
          }}
        />
      </div>
    );
  }

  dropdown() {
    let vals = DROPDOWN_OPTIONS[this.props.type];
    if (this.props.type == 'main_product') {
      let value = [];
      ['regplate', 'brand_name', 'model_name', 'model_info'].map(t => {
        if (t == 'regplate') {
          return this.props.vehicle[t] ? value.push(formatLicensePlate(this.props.vehicle[t])) : null;
        }
        return this.props.vehicle[t] ? value.push(this.props.vehicle[t]) : null;
      });
      this.props.vehicle.model_info ? this.props.vehicle.model_info : 'no selection';
      value.join(' ') && this.props.setValue(value.join(' '), this.props.type);
      vals = value.join(' ') ? [value.join(' ')] : [];
    }

    let options = vals.map(val => ({
      label: this.lbl(`vehicle.order.${this.props.type}.${val}`),
      value: val,
    }));

    let value = options.find(o => o.value == this.props.value);
    if (this.props.type == 'transport') {
      value = this.props.value ? this.props.value : options.find(o => o.value == this.props.value);
    }
    return (
      <div className={styles.container}>
        <Dropdown
          className={styles.dropdown}
          options={options}
          value={value}
          onChange={pair => this.props.setValue(pair.value)}
        />
      </div>
    );
  }

  buttonsOptions() {
    let vals = BUTTONS_OPTIONS[this.props.type];

    return (
      <div className={styles.containerButtons}>
        {vals.map(val => (
          <Button
            key={val}
            className={this.props.value === val ? styles.activeButton : styles.buttonValue}
            onClick={() => this.props.setValue(val)}
          >
            {val}
          </Button>
        ))}
      </div>
    );
  }

  detailsField() {
    return (
      <textarea className="form-control" value={this.props.value} onChange={evt => this.props.setValue(evt.target.value)} />
    );
  }

  reset() {
    this.setState({ ...STATE });
  }

  render() {
    if (this.props.work) return <Loader small />;
    return <Container>{this.wrap(this.renderField())}</Container>;
  }

  renderField() {
    if (this.props.value === undefined) return null;

    if (this.isDropbox()) {
      return this.dropdown();
    }

    if (this.isButtonsOptions()) {
      return this.buttonsOptions();
    }

    if (this.isTextariaBlock()) {
      return this.detailsField();
    }

    if (this.isButtonBlock()) {
      return (
        <div className={styles.buttonContainer}>
          <ButtonComponent
            style="ButtonSoftEdit"
            size="btn-sm"
            className={cn({
              [styles.activeButtonYes]: this.props.value === '1',
              [styles.defaultButtonYes]: this.props.value !== '1',
            })}
            onClick={() => this.props.setValue('1', this.props.type)}
          >
            YES
          </ButtonComponent>
          <ButtonComponent
            style="ButtonSoftDelete"
            size="btn-sm"
            className={cn({
              [styles.activeButtonNo]: this.props.value === '0',
              [styles.defaultButtonNo]: this.props.value !== '0',
            })}
            onClick={() => {
              if (this.props.type == 'fix_damages') {
                this.props.setValue('', 'fixed_damages_details');
                return this.props.setValue('0', this.props.type);
              }
              return this.props.setValue('0', this.props.type);
            }}
          >
            NO
          </ButtonComponent>
        </div>
      );
    }
    if (this.isCheckbox()) {
      return (
        <CheckboxComponent
          checked={this.props.value === '1'}
          onChange={() => {
            const value = this.props.value === '1' ? '0' : '1';
            return this.props.setValue(value);
          }}
        >
          {this.lbl(`vehicle.property.${this.props.type}`)}
        </CheckboxComponent>
      );
    }
    switch (this.props.type) {
      case 'total_price':
        return (
          <div className={styles.priceBox}>
            <div className={styles.valueBox}>
              <h6>{this.lbl('vehicle.order.total_price')}</h6>
            </div>

            <div className={styles.inputPrice}>
              {/* <input
                className="form-control"
                type="number"
                disabled="true"
                readOnly
                value={+this.props.values?.main_cost + this.props.secondaryTotalPrice || ''}
              /> */}
              € {((Number(this.props.values?.main_cost) || 0) + (Number(this.props?.secondaryTotalPrice) || 0)).toFixed(2)}
            </div>
          </div>
        );

      case 'seller':
        return (
          <CompanyUsersSearchSelect
            order
            key={`${this.props.type}-${this.props.values.client_company}`}
            type={this.props.type}
            userValue={this.props.value}
            onChange={value => this.props.setValue(value)}
          />
        );

      case 'bpm_guarantee_sum':
        return (
          <div>
            <div className={styles.inputPrice} style={{ width: '300px' }}>
              <div className={styles.decoratorLabel}>Borgbedrag in €</div>
              <input
                className="form-control"
                name={'borgbedrag'}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value, 'bpm_guarantee_sum')}
              />
            </div>
          </div>
        );
      case 'comment':
        return (
          <div>
            <label className="form-label">{this.lbl('vehicle.order.commentinvoice')}</label>

            <textarea
              className="form-control"
              value={this.props.value}
              onChange={evt => this.props.setValue(evt.target.value, 'comment')}
            />
          </div>
        );

      case 'main_cost':
        let values = ['brand_name', 'model_name', 'model_info', 'regplate']
          .map(t => this.props.vehicle[t] || '')
          .filter(t => t)
          .join(' ');
        return (
          <>
            <div className={styles.priceBox} style={{ display: 'flex', alignItems: 'center' }}>
              <div className={styles.valueBox} style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                {/* <VehicleAvatar vehicle={this.props.vehicle} /> */}
                <div>
                  <h5>{this.props.vehicle.brand_name + ' ' + this.props.vehicle.model_name}</h5>
                  {/* <h6>{this.props.vehicle.model_info}</h6> */}
                  {/* <h6>{formatLicensePlate(this.props.vehicle.regplate)}</h6> */}
                  {/* <h6>{this.props.vehicle.vin}</h6> */}
                </div>

                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginLeft: 'auto' }}>
                  <div className={styles.decoratorLabel} style={{ marginLeft: '8px' }}>
                    €
                  </div>
                  <div
                    className={styles.inputPrice}
                    style={{ flexBasis: '20%', flexShrink: 1, flexGrow: 1, marginLeft: '8px' }}
                  >
                    <input
                      className="form-control"
                      disabled={this.props.isDisabledMainProd}
                      value={this.props.value}
                      style={{ textAlign: 'left', width: '120%' }} // Ensure input takes full width of the container
                      onChange={evt => {
                        this.props.setValue(evt.target.value);
                        this.calculate(evt.target.value);
                        return this.props.setValue(+evt.target.value + this.props.secondaryTotalPrice, 'total_price');
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </>
        );
    }
  }
}

VehicleCreateOrderFieldComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWork(REQUEST_VEHICLE_PROPERTY_UPDATE),
    value: selectNewOrderValue(ownProps.type),
    values: selectNewOrder(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setValue(value, name = null) {
      name = name ?? ownProps.type;
      dispatch(setNewOrderValue(name, value));
    },

    initiateValue() {
      dispatch(initiateNewOrderValue(ownProps.type));
    },
    calculateFinancialAmounts(subject, callback) {
      dispatch(calculateFinancialAmounts(subject, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleCreateOrderField = compose(withConnect, withRouter)(VehicleCreateOrderFieldComp);
